/**
 * LLM observability (AI Usage) REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = `${API_BASE_URL}/observability`;

export async function fetchObservabilityStatus() {
  const res = await axios.get(`${base}/status`);
  return res.data;
}

/** Projects with LLM calls and cost per gate. @param {{ days?: number }} params */
export async function fetchLlmProjects(params = {}) {
  const res = await axios.get(`${base}/projects`, { params });
  return res.data;
}

/** @param {{ days?: number, projectId?: number|string, flow?: string, limit?: number }} params */
export async function fetchLlmRuns(params = {}) {
  const res = await axios.get(`${base}/runs`, { params });
  return res.data;
}

export async function fetchLlmRun(runId) {
  const res = await axios.get(`${base}/runs/${encodeURIComponent(runId)}`);
  return res.data;
}

export async function fetchLlmCall(runId, seq) {
  const res = await axios.get(`${base}/runs/${encodeURIComponent(runId)}/calls/${seq}`);
  return res.data;
}

/** Latest LLM run per step of a project, for the gate pages' "See how" links. */
export async function fetchLlmProvenance(projectId) {
  const res = await axios.get(`${base}/provenance`, { params: { projectId } });
  return res.data;
}
